import React, { lazy, Suspense } from "react";
import { Route, Routes, Outlet } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useAuth } from "./context/userContext.js";
import NotificationPrompt from "./components/reusable/NotificationPormpt.js";

import ScrollToTop from "./components/reusable/ScrollToTop.js";
import Loader from "./components/Loader/Loader.js";
import AffiliateDashboard from "./pages/affiliate/Dashboard.js";
import RedirectSpinner from "./components/RedirectSpinner.js";

const Home = lazy(() => import("./pages/Home"));
const PrivacyPolicy = lazy(() => import("./pages/policy/PrivacyPolicy"));
const ShippingPolicy = lazy(() => import("./pages/policy/ShippingPolicy"));
const RefundPolicy = lazy(() => import("./pages/policy/RefundPolicy"));
const TermsCondition = lazy(() => import("./pages/policy/TermsCondition"));
const PageNotFound = lazy(() => import("./pages/PageNotFound"));
const Register = lazy(() => import("./pages/Register"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const Profile = lazy(() => import("./pages/Profile"));
// const Checkout = lazy(() => import("./pages/Checkout"));
const ProductDetail = lazy(() => import("./pages/product/ProductDetail"));
const OrderDetails = lazy(() => import("./pages/OrderDetails"));
const OrderInvoice = lazy(() => import("./pages/OrderInvoice"));
const PaymentFail = lazy(() => import("./components/PaymentMsg").then(m => ({ default: m.PaymentFail })));
const PaymentSuccess = lazy(() => import("./components/PaymentMsg").then(m => ({ default: m.PaymentSuccess })));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const SaajHoney = lazy(() => import("./pages/SaajHoney"));
const BuffaloGhee = lazy(() => import("./pages/BuffaloGhee"));
const CowGhee = lazy(() => import("./pages/CowGhee"));
const AllBlogs = lazy(() => import("./pages/blogs/AllBlogs"));
const BlogDetail = lazy(() => import("./pages/blogs/BlogDetail"));

// Protected Route Component



const App = () => {
  const { auth, loading } = useAuth();

  return loading ? (
    <Loader />
  ) : (
    <>
      <ScrollToTop />
      <ToastContainer />
      <NotificationPrompt />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public Routes */}
          <Route exact path="/" element={<Home />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/reset-password/:token" element={<ResetPassword />} />
          <Route exact path="/verify-email/:token" element={<VerifyEmail />} />
          <Route exact path="/our-story" element={<AboutUs />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/organic-honey" element={<SaajHoney />} />
          <Route exact path="/blogs" element={<AllBlogs />} />
          <Route exact path="/blogs/:slug" element={<BlogDetail />} />
          <Route exact path="/a2-bilona-cow-ghee" element={<CowGhee />} />
          <Route exact path="/a2-bilona-buffalo-ghee" element={<BuffaloGhee />} />
          <Route exact path="/products/:id" element={<ProductDetail />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
          <Route exact path="/refund-policy" element={<RefundPolicy />} />
          <Route exact path="/term-condition" element={<TermsCondition />} />

          {/* Affiliate Routes */}


          {/* <Route path="/account/checkout" element={<Checkout />} /> */}

          <Route
            path="/account"
            element={
              auth?.user?._id ? (
                <Outlet />
              ) : (
                <RedirectSpinner />
              )
            }
          >
            <Route path="profile" element={<Profile />} />
            <Route path="payment-fail" element={<PaymentFail />} />
            <Route path="payment-success" element={<PaymentSuccess />} />
            <Route path="order-invoice/:orderId" element={<OrderInvoice />} />
            <Route path="order-details/:orderId" element={<OrderDetails />} />

          </Route>

          <Route
            path="/account"
            element={
              auth?.user?._id && auth?.user?.role === 12 ? (
                <Outlet />
              ) : (
                <RedirectSpinner />
              )
            }
          >
            <Route path="dashboard" element={<AffiliateDashboard />} />

          </Route>

          {/* Fallback - 404 Page */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense >
    </>
  );
};

export default App;